import { Box, Button } from '@mui/material';
import BlogCategoryItem from './BlogCategoryItem';

const BlogCategory = ({ pages }) => {

  return (
    <Box display="flex" sx={{ 
      flexWrap:'wrap', 
    }}>
      {
        pages && pages.map((page) => {
          return (
            <Box
              sx={{
                flex: ' 0 0 33.33%' /* Ogni elemento occupa un terzo della larghezza */,
                boxSizing: 'border-box',
                padding: '25px',
                '&:nth-child(3n+1)': {
                  paddingLeft: '0',
                },
                '&:nth-child(3n)': {
                  paddingRight: '0',
                },
                '@media(max-width: 900px)': {
                  flex: ' 0 0 50%' /* Ogni elemento occupa un terzo della larghezza */,
                  '&:nth-child(3n+1)': {
                    paddingLeft: '25px',
                  },
                  '&:nth-child(3n)': {
                    paddingRight: '25px',
                  },
                  '&:nth-child(2n+1)': {
                    paddingLeft: '0px',
                  },
                  '&:nth-child(2n)': {
                    paddingRight: '0px',
                  },
                },
                '@media(max-width: 650px)': {
                  flex: ' 0 0 100%' /* Ogni elemento occupa un terzo della larghezza */,
                  padding: '0px 0px 25px 0px',
                  '&:nth-child(3n+1)': {
                    paddingLeft: '0px',
                  },
                  '&:nth-child(3n)': {
                    paddingRight: '0px',
                  },
                },
              }}>
              <BlogCategoryItem page={page} />
            </Box>
          );
        })
      }
    </Box>
  );
};

export default BlogCategory;
